"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var __1 = require("..");
var hooks_1 = require("../../hooks");
var icons_1 = require("../../icons");
var variables_1 = require("../../style/variables");
var styles = {
    container: react_1.css({
        background: "var(" + variables_1.RootColor.White + ")",
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
        borderLeftWidth: 0,
        ':last-of-type': {
            borderTopRightRadius: 6,
            borderBottomRightRadius: 6,
        },
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        height: '100%',
    }),
    collapsedContainer: react_1.css({
        width: 40,
        cursor: 'pointer',
        ':hover': {
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
        },
    }),
};
var CollapsiblePanel = function (_a) {
    var title = _a.title, _b = _a.width, width = _b === void 0 ? 325 : _b, children = _a.children, actions = _a.actions, providedCollapsed = _a.collapsed, onCollapsedChanged = _a.onCollapsedChanged, props = __rest(_a, ["title", "width", "children", "actions", "collapsed", "onCollapsedChanged"]);
    var _c = hooks_1.useControlledState({
        value: providedCollapsed,
        onChange: onCollapsedChanged,
        defaultValue: false,
    }), collapsed = _c[0], setCollapsed = _c[1];
    var expanded = !collapsed;
    return (react_1.jsx("div", __assign({ css: [
            styles.container,
            { width: width },
            expanded ? undefined : styles.collapsedContainer,
        ] }, props),
        react_1.jsx(__1.Flex, { direction: "column", css: { width: width, display: expanded ? 'flex' : 'none', height: '100%' } },
            react_1.jsx(__1.Flex, { alignItems: "center", justifyContent: "space-between", css: {
                    height: 72,
                    padding: 16,
                    borderBottom: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
                } },
                react_1.jsx(__1.Text.Body, { size: "md", weight: "semibold", color: "var(" + variables_1.TextColor.HEAD + ")" }, expanded ? title : undefined),
                react_1.jsx(__1.Flex, null,
                    (actions === null || actions === void 0 ? void 0 : actions.length) ? (actions.map(function (buttonProps) { return (react_1.jsx(__1.Button, __assign({ variant: "flush" }, buttonProps, { size: "default" }))); })) : null,
                    react_1.jsx(__1.Button, { variant: "flush", icon: icons_1.ChevronLeftDouble, onClick: function () { return setCollapsed(true); } }))),
            react_1.jsx(__1.Flex, { direction: "column", css: { flex: 1, overflow: 'overlay' } }, children)),
        react_1.jsx(__1.Flex, { gap: 8, direction: "column", alignItems: "center", css: {
                width: 40,
                display: expanded ? 'none' : undefined,
                padding: '26px 0',
            }, onClick: function () { return setCollapsed(false); } },
            react_1.jsx(icons_1.ChevronRightDouble, { size: 20, color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")" }),
            react_1.jsx(__1.Text.Body, { size: "md", css: {
                    writingMode: 'vertical-lr',
                    transform: 'rotate(180deg)',
                    zIndex: 2,
                }, color: "var(" + variables_1.RootColor.Gray.DEFAULT + ")" }, title))));
};
exports.default = CollapsiblePanel;
